import '../styles/_modal.scss';

import React, { useEffect, useState } from 'react';
import { useIdleTimer, PresenceType } from 'react-idle-timer'
import { _resetState } from '../_states/_resetState';
import { config } from '../Services/_config';
import FocusTrap from "focus-trap-react";

export const TimeoutModal = () => {
	const timeout = (config.timeout.totalTimeInMins * 60 * 1000);
	const promptBeforeIdle = (config.timeout.promptBeforeIdleInMins * 60 * 1000);
	const [modalOpen, setModalOpen] = useState(false);

	const [state, setState] = useState('Active');
	const [remaining, setRemaining] = useState(timeout);
	const [hasTimedOut, setHasTimedOut] = useState(false);

	const onPresenceChange = (presence) => {
		const isIdle = presence.type === 'idle';
		const isPrompted = presence.type === 'active' && presence.prompted;
		const isActive = presence.type === 'active' && !presence.prompted;

		if (isIdle) {
			setState('Idle');
			setHasTimedOut(true);
		} else if (isPrompted) {
			setState('Prompted');
		} else if (isActive) {
			setState('Active');
		}
	}

	const onPrompt = () => {
		setState('Prompted');
		setModalOpen(true);
		setHasTimedOut(false);
	}
	const { getRemainingTime, activate, isIdle, isPrompted } = useIdleTimer({
		onPrompt,
		onPresenceChange,
		timeout,
		promptBeforeIdle,
		throttle: 500
	})

	const continueForm = () => {
		activate();
		setModalOpen(false);
	}

	const handleStillHere = () => {
		activate();
		setModalOpen(false);
		_resetState.setResetState(true);
		window.location.reload();
	}

	useEffect(() => {
		const interval = setInterval(() => {
			setRemaining(Math.ceil(getRemainingTime() / 1000));
		}, 500)

		return () => {
			clearInterval(interval);
		}
	})

	return (
		modalOpen &&
		<FocusTrap>
			<div id="modal-container">
				<div id="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalInfo">
					{!hasTimedOut &&
						<>
							<h2 id="modalTitle">Your application will timeout soon</h2>
							<div id="modalInfo" className="messages">
								<p>We will reset your application if you do not respond in {config.timeout.promptBeforeIdleInMins} minutes. We do this to keep your information secure.</p>
							</div>
							<div className="buttons">
								<button autoFocus onClick={() => { continueForm(); }} className="btn btn-primary">Continue application</button>
							</div>
						</>
					}

					{hasTimedOut &&
						<>
							<h2 id="modalTitle">Your session has expired</h2>
							<div id="modalInfo" className="messages">
								<p>Your application has timed out and your entered data has been disposed.</p>
							</div>
							<div className="buttons">
								<button onClick={() => { handleStillHere(); }} className="btn btn-primary">Restart this form</button>
							</div>
						</>
					}
				</div>
			</div>
		</FocusTrap>
	);
};
